import PropTypes from "prop-types";
import React from "react";
import messages from "components/messagesDescription";
import { intlShape } from "react-intl";

const LifeStage = ({ intl, lifeStage, employee, getImageUrl }) => {
  if (employee) {
    return (
      <section>
        <h2>
          {intl.formatMessage(messages.mylifestageDescription)}
        </h2>
        <img src={getImageUrl(lifeStage.value, employee.data)} alt="unknown" />
        <div>
          {intl.formatMessage({
            id: lifeStage.lookupValue,
            defaultMessage: lifeStage.lookupValue,
          })}
        </div>
      </section>
    );
  }

  return null;
};

LifeStage.propTypes = {
  intl: intlShape.isRequired,
  lifeStage: PropTypes.object,
  employee: PropTypes.object,
  getImageUrl: PropTypes.func,
};

export default LifeStage;



// WEBPACK FOOTER //
// ./components/employee/LifeStage.js